import React, { useState, useEffect } from "react";
import "./upload.css";
import "../../global/GlobalStyle.css";
import ModalComponent from "../../global/Modal"; 
import { getEmployeeDetails } from "../../../api/ApiConfig";

export default function Upload() {
  const [showModal, setShowModal] = useState(false);
  const [employee, setEmployee] = useState(null); // to store emp details

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const getInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(" ");
    const first = parts[0]?.[0] || "";
    const second = parts[1]?.[0] || "";
    return (first + second).toUpperCase();
  };

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const res = await getEmployeeDetails(); // Make API call       
        if (res) {
          setEmployee(res);
        }
      } catch (err) {
        console.error("Error fetching employee details:", err);
      }
    };
    fetchEmployee();
  }, []);

  return (  
    <>
      <div className="upload-container">
        <div className="input-row">
          <div className="avatar">
            {employee ? getInitials(employee.name) : ""}
          </div>
          <input
            type="text"
            className="search-field-global-search"
            placeholder={`What's on your mind, ${employee?.name || "..."}`}
            onClick={handleOpenModal}
            readOnly
          />
        </div>
      </div>

      {/* Modal Component */}
      <ModalComponent show={showModal} handleClose={handleCloseModal} />
    </>
  );
}
